import api from './api';

class AuthService {
  constructor() {
    this.user = null;
    this.permissions = [];
    this.menuPermissions = null;
    console.log('=== AUTHSERVICE CONSTRUCTOR ===');
    this.loadUserFromStorage();
    console.log('After constructor - this.user:', this.user);
    console.log('After constructor - this.permissions:', this.permissions);
  }

  loadUserFromStorage() {
    try {
      const userData = localStorage.getItem('userData');
      console.log('=== LOADING USER FROM STORAGE ===');
      console.log('userData from localStorage:', userData);
      
      if (userData) {
        const user = JSON.parse(userData);
        console.log('Parsed user data:', user);
        this.user = user;
        this.permissions = user.permissions || [];
        console.log('User set to:', this.user);
        console.log('Permissions set to:', this.permissions);
      } else {
        console.log('No userData found in localStorage');
      }
    } catch (error) {
      console.error('Error loading user data from storage:', error);
    }
  }

  saveUserToStorage(userData) {
    try {
      console.log('=== SAVING USER TO STORAGE ===');
      console.log('User data to save:', userData);
      
      localStorage.setItem('userData', JSON.stringify(userData));
      this.user = userData;
      this.permissions = userData.permissions || [];
      
      console.log('User saved to localStorage');
      console.log('this.user set to:', this.user);
      console.log('this.permissions set to:', this.permissions);
    } catch (error) {
      console.error('Error saving user data to storage:', error);
    }
  }

  clearUserData() {
    localStorage.removeItem('userData');
    this.user = null;
    this.permissions = [];
    this.menuPermissions = null;
  }

  async login(user, password) {
    try {
      console.log('=== AUTHSERVICE LOGIN ===');
      console.log('User:', user);

      // Evitar que tokens viejos interfieran con el login
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userData');
      sessionStorage.removeItem('sessionExpired');
      this.clearUserData();
      
      const response = await api.post('/auth/login', { user, password });
      const { token, refreshToken, user: userData } = response.data.payload;
      
      console.log('=== LOGIN API RESPONSE ===');
      console.log('Full response:', response.data);
      console.log('User data received:', userData);
      console.log('Token received:', token);
      
      // Guardar tokens
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('isAuthenticated', 'true');
      
      // Guardar datos del usuario
      this.saveUserToStorage(userData);
      
      // Verificar que se guardó correctamente
      const savedData = localStorage.getItem('userData');
      console.log('Datos guardados en localStorage:', savedData);
      
      // Cargar permisos de menú (no bloquea el login si falla)
      try {
        await this.loadMenuPermissions();
      } catch (menuError) {
        console.warn('No se pudieron cargar permisos de menú:', menuError);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error en authService.login:', error);
      throw error;
    }
  }

  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    const { token, refreshToken, user: userData } = response.data.payload;
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('isAuthenticated', 'true');
    this.saveUserToStorage(userData);
    return response.data;
  }

  async loadMenuPermissions() {
    try {
      const response = await api.get('/authorization/my-menu-permissions');
      this.menuPermissions = response.data.payload.menuPermissions;
      return this.menuPermissions;
    } catch (error) {
      console.error('Error loading menu permissions:', error);
      return null;
    }
  }

  // Función centralizada para verificar permisos desde cualquier fuente
  static checkPermissionFromUserData(userData, permission) {
    try {
      if (!userData || !userData.permissions) {
        return false;
      }

      // Si es Admin, tiene todos los permisos
      if (userData.role === 'Admin') {
        return true;
      }

      // Verificar permiso específico
      if (Array.isArray(userData.permissions)) {
        return userData.permissions.some(p => {
          // Si es un string simple, comparar directamente
          if (typeof p === 'string') {
            return p === permission;
          }
          // Si es un objeto, buscar en las propiedades
          return p.resource_action === permission || 
                 p.resourceAction === permission ||
                 p.name === permission;
        });
      }

      return false;
    } catch (error) {
      console.error('Error verificando permiso:', error);
      return false;
    }
  }

  // Función para verificar permisos directamente desde localStorage
  static checkPermissionFromStorage(permission) {
    try {
      const userData = localStorage.getItem('userData');
      if (!userData) return false;
      
      const user = JSON.parse(userData);
      return this.checkPermissionFromUserData(user, permission);
    } catch (error) {
      console.error('Error verificando permiso desde storage:', error);
      return false;
    }
  }

  // Función para verificar múltiples permisos
  static checkMultiplePermissions(permissions, requireAll = false, fromStorage = false) {
    if (!permissions || permissions.length === 0) return true;

    if (requireAll) {
      // Verificar que tenga TODOS los permisos
      return permissions.every(permission => 
        fromStorage 
          ? this.checkPermissionFromStorage(permission)
          : authService.hasPermission(permission)
      );
    } else {
      // Verificar que tenga AL MENOS UNO de los permisos
      return permissions.some(permission => 
        fromStorage 
          ? this.checkPermissionFromStorage(permission)
          : authService.hasPermission(permission)
      );
    }
  }

  // Verificar si el usuario tiene un permiso específico
  hasPermission(permission) {
    console.log('=== HAS PERMISSION CHECK ===');
    console.log('Checking permission:', permission);
    console.log('this.permissions:', this.permissions);
    
    if (!this.permissions || this.permissions.length === 0) {
      console.log('No permissions found');
      return false;
    }

    // Si es Admin, tiene todos los permisos
    if (this.user?.role === 'Admin') {
      console.log('User is Admin, granting permission');
      return true;
    }

    // Verificar permiso específico en el array
    const hasPermission = this.permissions.some(p => {
      // Si es un string simple, comparar directamente
      if (typeof p === 'string') {
        return p === permission;
      }
      // Si es un objeto, buscar en las propiedades
      return p.resource_action === permission || 
             p.resourceAction === permission ||
             p.name === permission;
    });
    
    console.log('Permission found:', hasPermission);
    return hasPermission;
  }

  // Verificar si el usuario tiene al menos uno de los permisos
  hasAnyPermission(permissions) {
    console.log('=== HAS ANY PERMISSION CHECK ===');
    console.log('Checking permissions:', permissions);
    
    // Si es Admin, tiene todos los permisos
    if (this.user?.role === 'Admin') {
      console.log('User is Admin, granting access');
      return true;
    }

    return permissions.some(permission => this.hasPermission(permission));
  }

  // Verificar si el usuario tiene todos los permisos
  hasAllPermissions(permissions) {
    console.log('=== HAS ALL PERMISSIONS CHECK ===');
    console.log('Checking permissions:', permissions);
    
    // Si es Admin, tiene todos los permisos
    if (this.user?.role === 'Admin') {
      console.log('User is Admin, granting access');
      return true;
    }

    return permissions.every(permission => this.hasPermission(permission));
  }

  // Verificar si el usuario tiene un rol específico
  hasRole(role) {
    console.log('=== HAS ROLE CHECK ===');
    console.log('Checking role:', role);
    console.log('this.user:', this.user);
    console.log('this.user?.role:', this.user?.role);
    const result = this.user?.role === role;
    console.log('Result:', result);
    return result;
  }

  // Verificar si es admin
  isAdmin() {
    return this.hasRole('Admin');
  }

  // Verificar si es mecánico
  isMechanic() {
    return this.hasRole('Mecanico');
  }

  // Verificar si es recepcionista
  isReceptionist() {
    return this.hasRole('Recepcionista');
  }

  // Obtener permisos de menú
  getMenuPermissions() {
    return this.menuPermissions;
  }

  // Verificar permisos específicos de menú
  canViewUsers() {
    return this.menuPermissions?.canViewUsers || false;
  }

  canCreateUsers() {
    return this.menuPermissions?.canCreateUsers || false;
  }

  canViewRoles() {
    return this.menuPermissions?.canViewRoles || false;
  }

  canManageRoles() {
    return this.menuPermissions?.canManageRoles || false;
  }

  canViewClients() {
    return this.menuPermissions?.canViewClients || false;
  }

  canCreateClients() {
    return this.menuPermissions?.canCreateClients || false;
  }

  canViewSchedule() {
    return this.menuPermissions?.canViewSchedule || false;
  }

  canViewOwnSchedule() {
    return this.menuPermissions?.canViewOwnSchedule || false;
  }

  canCreateAppointments() {
    return this.menuPermissions?.canCreateAppointments || false;
  }

  canViewVehicles() {
    return this.menuPermissions?.canViewVehicles || false;
  }

  canCreateVehicles() {
    return this.menuPermissions?.canCreateVehicles || false;
  }

  canViewInvoices() {
    return this.menuPermissions?.canViewInvoices || false;
  }

  canCreateInvoices() {
    return this.menuPermissions?.canCreateInvoices || false;
  }

  canViewProviders() {
    return this.menuPermissions?.canViewProviders || false;
  }

  canViewReports() {
    return this.menuPermissions?.canViewReports || false;
  }

  canViewProducts() {
    return this.menuPermissions?.canViewProducts || false;
  }

  // Refrescar datos del usuario y permisos
  async refreshUserData() {
    try {
      const response = await api.get('/auth/me'); // Necesitarías crear este endpoint
      const userData = response.data.payload;
      
      this.saveUserToStorage(userData);
      await this.loadMenuPermissions();
      
      return userData;
    } catch (error) {
      console.error('Error refreshing user data:', error);
      throw error;
    }
  }

  // Obtener información del usuario actual
  getCurrentUser() {
    console.log('=== GET CURRENT USER ===');
    console.log('this.user:', this.user);
    return this.user;
  }

  // Obtener rol del usuario actual
  getUserRole() {
    console.log('=== GET USER ROLE ===');
    console.log('this.user?.role:', this.user?.role);
    return this.user?.role;
  }

  // Obtener permisos del usuario actual
  getCurrentUserPermissions() {
    return this.permissions;
  }
}

// Instancia singleton
const authService = new AuthService();
export default authService;